import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { ToastsContainer } from '../ToastsContainer/ToastsContainer.js';
import { ToastsContext } from '../ToastsContext/ToastsContext.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["children", "destroyedToastIds", "onDestroy"];
var Toasts = /*#__PURE__*/React.forwardRef(function Toasts2(props, ref) {
  var children = props.children,
      destroyedToastIds = props.destroyedToastIds,
      onDestroy = props.onDestroy,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/jsxs(ToastsContext, {
    children: [/*#__PURE__*/jsx(ToastsContainer, _objectSpread(_objectSpread({
      destroyedToastIds: destroyedToastIds,
      onDestroy: onDestroy
    }, rest), {}, {
      ref: ref
    })), children]
  });
});
Toasts.propTypes = {
  "children": _PropTypes.node,
  "destroyedToastIds": _PropTypes.arrayOf(_PropTypes.string),
  "onDestroy": _PropTypes.func
};
Toasts.displayName = "Toasts";

export { Toasts };
